import React from 'react'
import './styles.css'
import { FeatureCard } from 'src/components/inline/featureCard'

interface FeatureCardGroupProps {
  data: {
    layoutType: '3across' | '4across' | '6across'
    cards: any[]
  }
}

export const FeatureCardGroup = ({ data }: FeatureCardGroupProps) => {
  const { layoutType, cards } = data

  return (
    <div className={`feature-card-group layout-${layoutType}`}>
      {cards?.map(card => (
        <FeatureCard key={card._key} data={card} />
      ))}
    </div>
  )
}
